import axios from "axios";

let api;

function accessToServerHost() {
  let host = location.host;
  let urlSlice = host.split(":");
  let api = "http://" + urlSlice[0] + ":8080";
  return api;
}

api = accessToServerHost();

let platform = {
  name: "QMS",
  api: api,
  token: sessionStorage.getItem("token"),
};

window.$platform = platform;

// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL:
    process.env.NODE_ENV !== "production"
      ? "http://175.24.227.116:8080"
      : $platform.api,
  // baseURL: '/api',
  // baseURL: api,
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
  },
});

// axios 请求封装
export const http = (method, url, config = {}) => {
  const { loading = true, token = false } = config;

  if (token) {
    let token = window.sessionStorage.getItem("token")
    if (method === "post" || method === "put") {
      if (url === "/scrap") {
        config.data.token = token;
      } else {
        let obj = {};
        obj.token = token;
        obj.data = config.data;
        config.data = obj;
      }
    }
  }

  if (loading) {
    $gb.loading(true, "加载中");
  }

  return axiosInstance(Object.assign(config, { method, url }))
    .then(({ data }) => {
      if (data && typeof data == "string") {
        return JSON.parse(data);
      } else {
        return data;
      }
    })
    .catch((err) => {
      console.log(err);
      return err;
    })
    .finally(() => {
      $gb.loading(false, "");
    });
};
